export default __webpack_public_path__ + "static/media/help.94b17531.gif";